export enum ScoringStatusExam {
  WAITING = 2,
  COMPLETED = 3,
  SCORING = 6,
}
